import * as types from '../constants/actionTypes'
import reject from 'lodash/reject'
import { ConversationSummary } from '../components/types'

export interface ConvSummaryState {
  assigned: ConversationSummary[]
  allSummaries: ConversationSummary[]
  prioritySummaries: ConversationSummary[]
}

const initialState: ConvSummaryState = {
  assigned: [],
  allSummaries: [],
  prioritySummaries: [],
}

export const convSumsState = (
  state: ConvSummaryState = initialState,
  action
) => {
  switch (action.type) {
    case types.ReceivedConvSums:
      return {
        ...state,
        allSummaries: action.data.conversation_summaries,
      }
    case types.ReceivedPriorityConvSums:
      return {
        ...state,
        prioritySummaries: action.data.conversation_summaries,
      }
    case types.ReceivedAssignedConvSums:
      return {
        ...state,
        assigned: action.data.conversation_summaries,
      }
    case types.RemoveConvSum:
      return {
        ...state,
        allSummaries: reject(
          state.allSummaries,
          (obj) => obj.id === action.data.id
        ),
      }
    case types.RemovePriorityConvSum:
      return {
        ...state,
        prioritySummaries: reject(
          state.prioritySummaries,
          (obj) => obj.id === action.data.id
        ),
      }
    case types.AddPriorityConvSum:
      return {
        ...state,
        prioritySummaries: [...state.prioritySummaries, action.data],
      }
    default:
      return state
  }
}

export const convSums = convSumsState
